// Hamburger jQuery version
// $('div.navbar-burger').on('click', function () {
  // $(this).toggleClass('is-active');
  // $('ul.main-menu').toggleClass('is-active');
// });

// Hamburger vanilla version
document.querySelectorAll('div.navbar-burger').forEach(function (burger) {
  burger.addEventListener('click', function () {
    burger.classList.toggle('is-active');
    document.querySelectorAll('ul.main-menu').forEach(function (menu) {
      menu.classList.toggle('is-active');
    });
  });
});
